import React, { useState, useEffect } from "react";
import DefaultTabList from "../../components/CategoryTab/DefaultTabList";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import bgImage from "../../assets/img/03_main_banner.png";
import instance from "../../services/services";
import { MY_INFO_URL } from "../../utils/urls";
import { useLanguage } from "../../hooks/useLanguage";

function Community(){
  const { t } = useLanguage();
  const [isMobile, setIsMobile] = useState(false); // 모바일에서 스와이퍼 작동
  const navigate = useNavigate();
  const location = useLocation();
  const [myInfo, setMyInfo] = useState(null); // 내 정보 데이터

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);


  const tabList = [
    { value: 'notice', name: t('notice') },
    { value: 'event', name: t('event') },
    { value: 'support', name: t('production_support') },
    { value: 'faq', name: t('frequently_asked_questions') },
    { value: 'inquiry', name: t('inquiry') },
    { value: 'customizing', name: t('customization') },
    { value: 'priceGuarantee', name: t('lowest_price_guarantee') },
    { value: 'credit', name: t('credit') },
  ];

  const activeTab = tabList.find(tab => location.pathname.includes(tab.value))?.value || 'notice';

  const handleActive = (tab) => {
    navigate(`/community/${tab.value}`);
  };

  // 현재 탭에 따른 배너 설명 텍스트 설정
  const getBannerDesc = () => {
    switch(activeTab) {
      case 'notice':
        return t('notice_desc');
      case 'event':
        return t('event_desc');
      case 'support':
        return t('production_support_desc');
      case 'faq':
        return t('frequently_asked_questions_desc');
      case 'inquiry':
        return t('inquiry_desc');
      case 'customizing':
        return t('customization_desc');
      case 'priceGuarantee':
        return t('lowest_price_guarantee_desc');
      case 'credit':
        return t('credit_desc');
      default:
        return t('notice_desc');
    }
  };

  const bannerDesc = getBannerDesc();

  // 내 정보
  useEffect(()=> {
    const fetchMyInfo = async () => {
      try {
        const response = await instance.post(MY_INFO_URL);
        setMyInfo(response.data.data)
      }
      catch (error){
        console.error("내 정보 가져오기 실패", error);
      }
    };
    fetchMyInfo();
  },[]);


  return(
    <div>
      <section className="comm_section">
        {/* 배너 */}
        <div 
          className="comm_banner"
          style={{backgroundImage:`url(${bgImage})`}}
        >
          <div className="comm_banner_inner">
            <h4>Community</h4>
            <p>{bannerDesc}</p>
          </div>
        </div>

        {/* 탭 */}
        <DefaultTabList
          tabList={tabList}
          activeValue={activeTab}
          isEnabledSwiper={isMobile}
          handleActive={handleActive}
        />

        <div className="comm_inner">
          <Outlet context={{ myInfo }}/>
        </div> 



      </section>

    </div>

  )
};

export default Community; 